import { promiseState,downloadFile } from 'annotation-tools/utils';
import React, { FC, memo, useCallback } from 'react';
import { CsvListView } from './csv-list-view';
import { ICsvType } from '../../../types/record/csv';
import { useToken } from '../../../global-state/auth-state';

import { useListFiltered } from '../../../functions/hooks/use-list-filtered';
import { csvList$ } from '../../../global-state/database/csv-list';
import { useLoadingPage } from '../../../global-state/show-loading-page';
import { viewTexts } from '../../../constants/view-texts';
import { NotFoundTemplate } from '../../shared/not-found-page-template';

// import { switchMap, withLatestFrom } from 'rxjs/operators';
import { getDownloadLink } from '../../../api/fetch-functions/csv/get-download-link';

export const CsvList: FC<{}> = memo(() => {

  const token = useToken()

  const {
    searchString,
    onSearchStringChange,
    page,
    onPageChange,
    rowsPerPage,
    setRowsPerPage: onRowsPerPageChange,
    numRows,
    listFilteredCurrentPage: csvListFiltered
  } = useListFiltered(csvList$);

  const downloadCsvButtonOnClick = useCallback(
    (csv: ICsvType) => {
      if (
        token === undefined
      ) {
        return;
      }
      getDownloadLink(token)(csv.id, 'CSV').then(res =>{
        if (res.type === 'error') {
          console.log(res.body);
          return;
        }
        downloadFile(res.body.url);
      })
    },
    [token]
  );

  useLoadingPage(csvListFiltered?.status === 'pending');

  return (
    <>
      {csvListFiltered === undefined ? (
        undefined
      ) : csvListFiltered.status === promiseState.error ? (
        <NotFoundTemplate message={viewTexts.notFoundMessages.userList} />
      ) : (
        <CsvListView
          searchString={searchString}
          onSearchStringChange={onSearchStringChange}
          page={page}
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          numRows={numRows}
          csvListFiltered={csvListFiltered.value.latest}
          downloadCsvOnClick={downloadCsvButtonOnClick}
        />
      )}
    </>
  );
});

CsvList.displayName = 'CsvList';
